const { createProductTiles } = require('../tiles/product-tile-factory');
const { map, filter } = require('lodash');

class NewProductsTileListController {
    constructor(settings, analyticsService, newProductsService, sortByKeys) {
        this.settings = settings;
        this.analyticsService = analyticsService;
        this.newProductsService = newProductsService;
        this.sortByKeys = sortByKeys;
    }

    $onInit() {
        this.sortOptions = { sortTypes: this.settings.new.sortOptions, sortContext: this.sortByKeys.NEW_KEY };
    }

    createTiles(response) {
        return {
            items: createProductTiles(response.Items),
            totalRecordCount: response.TotalRecordCount,
            aggregations: filter(response.Aggregations, a => a.ShowFilter),
        };
    }

    getTiles(pageSize, pageNumber, sortType, filters) {
        return this.newProductsService
            .getProducts(pageSize, pageNumber, sortType, filters)
            .then(response => this.createTiles(response));
    }

    createAnalyticsData(contentData) {
        return {
            pageNumber: contentData.pageNumber,
            currentCategory: { Description: 'New Products' },
            products: map(contentData.items, item => ({ Name: item.data.product.Name, Products: [item.data.product] })),
            inspirationCards: { Cards: contentData.inspirationCards },
            totalRecordCount: contentData.totalRecordCount,
            filters: contentData.filters,
            sortType: contentData.sortType ? contentData.sortType.Value : '',
            sortOptions: this.sortOptions,
        };
    }

    pushContentDataToAnalytics(contentData) {
        this.analyticsService.push({
            data: this.createAnalyticsData(contentData),
            type: this.analyticsService.mapperTypes.shop.productCategory,
        });
    }
}

NewProductsTileListController.$inject = ['Settings', 'AnalyticsService', 'NewProductsService', 'SortByKeys'];

const newProductsTileListComponentDefinition = {
    bindings: {
        pageNumber: '<',
        sortBy: '<',
        filter: '<',
    },
    controller: NewProductsTileListController,
    template: `
        <wow-tile-list
            list-title="'New Products'"
            page-number="$ctrl.pageNumber"
            sort-by="$ctrl.sortBy"
            sort-options="::$ctrl.sortOptions"
            filter="$ctrl.filter"
            get-tiles="$ctrl.getTiles(pageSize, pageNumber, sortType, filter)"
            push-content-to-analytics="$ctrl.pushContentDataToAnalytics(contentData)">

            <zero-result>
                <div class="newProductsTileList-zeroResult">
                    <h1 class="newProductsZeroResult-title">No new products found</h1>
                    <p>Sorry, no new products were found. Please check back soon.</p>
                </div>
            </zero-result>
        </wow-tile-list>
    `,
};

module.exports = {
    NewProductsTileListController,
    newProductsTileListComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/newproducts/newproducts-tile-list.component.js